<template>
    <div class="container" :style="containerStyleObj">
        <Row class="title-wrap" :style="titleWrapStyleObj" ref="titleWrap">
            <Col :xs="{ span: 24}" :sm="{ span: 24}" :md="{ span: 24}" :lg="{ span: 24}">
            <div class="title" :style="titleStyleObj">
                <img src="../../assets/images/databoard/head-left-icon.png"/>
                <span v-on:click="handleFullScreen()">普洱市智能大数据监管平台</span>
                <img src="../../assets/images/databoard/head-right-icon.png"/>
            </div>
            <div class="logo" :style="logoStyleObj">
                <img :src="`${logoPath}?${timestamp}`">
                <span class="split-line"></span>
                <img src="../../assets/images/databoard/ai-logo.png" style="margin: 3.5px 0;" />
            </div>
            <div class="full-screen" v-on:click="handleFullScreen()">
                <template v-if="!fullscreen">
                    <span class="full-icon"><img src="../../assets/images/databoard/full-screen-icon.png"/></span>
                    <span class="full-title">全屏</span>
                </template>
                <template v-else>
                    <span class="full-icon"><img src="../../assets/images/databoard/exit-full-screen-icon.png"/></span>
                    <span class="full-title">取消全屏</span>
                </template>
            </div>
            </Col>
        </Row>
        <div class="statistic-wrap" :style="statisticWrapStyleObj">
            <!--地图区域-->
            <div style="width: 66.67%;float:left;position: relative;">
            <city-map :token="token"></city-map>
            </div>
            <!--数据统计区域-->
            <div style="width: 33.33%;float:right">
            <district-dis-statics :titleHeight="titleHeight" :screenHeight="screenHeight"></district-dis-statics>
            <!--学科应用分析-->
            <subject-applica-analy :titleHeight="titleHeight" :screenHeight="screenHeight"></subject-applica-analy>
            <!--教学活动分析-->
            <tea-active-analyse :titleHeight="titleHeight" :screenHeight="screenHeight"></tea-active-analyse>
            </div>
        </div>
    </div>
</template>

<script>
    import {findLoginUserInfo} from '../../service/api'
    const cityMap = () => import("./modules/CityMap");
    const districtDisStatics = () => import("./modules/districtDisStatics");
    const subjectApplicaAnaly = () => import("./modules/subjectApplicaAnaly");
    const teaActiveAnalyse = () => import("./modules/teaActiveAnalyse");
    export default {
        name: 'nan-jin-statics-super',
        components: {
            cityMap,
            districtDisStatics,
            subjectApplicaAnaly,
            teaActiveAnalyse
        },
        data() {
            return {
                statisticHeight:'',
                isConvert: 1, //是否转换数字
                fullscreen: false,
                schoolData: {},
                newSchoolData: {},
                evlPer: 80,
                teaCourseware: [], //教师课件
                stuHomework: [], //学生作业
                teaClassBehavior: [], //教师课堂行为
                dynamicData: [], //实时动态
                baseData: [], //基础数据
                classInteractData: [], //课堂互动
                classInteractTotal: 0, //课堂互动总数
                teaBehaviorData: [], //教师行为
                stuBehaviorData: [], //学生行为
                ebookCountList: [], //校本书库
                top: [],
                left: [130, 140, 150, 160, 170, 180, 190, 200, 210, 230],
                color: ['#FFF', '#00d8ff', '#ffce23'],
                scrollInterval: {}, //动态滚动区间,
                scrollIngDynamicList: [],
                screenHeight: document.body.clientHeight, // 屏幕默认宽度
                containerStyleObj: {
                    height: ''
                },
                titleWrapStyleObj: {
                    height: ''
                },
                titleStyleObj: {
                    height: ''
                },
                logoStyleObj: {
                    height: ''
                },
                statisticWrapStyleObj: {
                    height: '',
                    margin: '0px 0px 10px 0px'
                },
                token:'',
                titleHeight: 0,
                countWeight: 700,
                previewMode: false,
                previewVideoMode: false,
                videoSrc: "",
                isShowModal: false,
                currentInter: {},
                tabsName: "", //标签页名称
                schoolId: this.$route.params.schoolId, //学校id
                logoPath: process.env.VUE_APP_DASH_LOGO_PATH,
                timestamp: (new Date()).getTime()
            }
        },
        created() {

        },
        watch: {},
        methods: {
            /**
             * 全屏
             */
            handleFullScreen() {
                let element = document.documentElement;
                if (this.fullscreen) {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                } else {
                    if (element.requestFullscreen) {
                        element.requestFullscreen();
                    } else if (element.webkitRequestFullScreen) {
                        element.webkitRequestFullScreen();
                    } else if (element.mozRequestFullScreen) {
                        element.mozRequestFullScreen();
                    } else if (element.msRequestFullscreen) {
                        // IE11
                        element.msRequestFullscreen();
                    }
                }
                this.fullscreen = !this.fullscreen;
            },
            /**
             * 获取token
             */
            getLoginUserInfo(){
                let _this = this;
                let userParam = {
                    userId: 'de1e8f495e634ce6bbc3f388335c2090'
                };
                this.$store.dispatch('getLoginUserInfo', userParam).then(res => {
                }).catch((res) => {
                    console.log(res);
                });
            }
        },
        mounted() {
            const _this = this;
            this.$nextTick(() => {
                let windowHeight = window.innerHeight;
                if (windowHeight < 900) {
                    windowHeight = 938;
                    document.getElementsByTagName("body")[0].className = "active";
                }
                let titleHeight = 128;
                let statisticHeight = windowHeight - titleHeight - 10;
                this.titleHeight = titleHeight;
                this.containerStyleObj.height = windowHeight + 'px';
                this.titleWrapStyleObj.height = titleHeight + 'px';
                this.titleStyleObj.height = (titleHeight * 0.4) - 10 + 'px';
                this.logoStyleObj.height = titleHeight * 0.3 + 'px';
                this.statisticWrapStyleObj.height = statisticHeight + 'px';
                this.getLoginUserInfo();
            });

            // 注：window.onresize只能在项目内触发1次
            window.onresize = function windowResize() {
                // 通过捕获系统的onresize事件触发我们需要执行的事件
                let windowHeight = document.body.clientHeight;
                if (windowHeight < 900) {
                    windowHeight = 938;
                    document.getElementsByTagName("body")[0].className = "active";
                }
                _this.screenHeight = windowHeight;
                let titleHeight = 128;
                let statisticHeight = windowHeight - titleHeight - 10;
                _this.titleHeight = titleHeight;
                _this.containerStyleObj.height = windowHeight + 'px';
                _this.titleWrapStyleObj.height = titleHeight + 'px';
                _this.titleStyleObj.height = (titleHeight * 0.4) - 10 + 'px';
                _this.logoStyleObj.height = titleHeight * 0.3 + 'px';
                _this.statisticWrapStyleObj.height = statisticHeight + 'px';
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../style/databoard";
    @import "../../style/detailPage";

    .panel-box {
        background-image: url("../../assets/images/databoard/modal-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%
    }

    @font-face {
        font-family: MaravaleExpanded;
        src: url('../../assets/fonts/digifaw.ttf'); //字体路径
    }

    .container {
        background-image: url("../../assets/images/databoard/bg.png");
        background-size: cover;
        background-repeat: no-repeat;
    }

    .title-wrap {
        background-image: url("../../assets/images/databoard/head-bg.png");
        background-repeat: no-repeat;
        background-position: top;
    }

    .count-wrap {
        height: 100%;
        background-image: url("../../assets/images/databoard/count-bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .full-screen {
        background-image: url("../../assets/images/databoard/full-screen-bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .statis-report {
        background-image: url("../../assets/images/databoard/full-screen-bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .bg1 {
        background-image: url("../../assets/images/databoard/title-bg1.png");
    }
</style>

<style lang="scss">
    body {
        background-color: #000 !important;
        overflow-x: hidden;
        overflow-y: hidden;
    }

    .active {
        overflow-x: auto;
        overflow-y: auto;
    }
</style>